import React, { useEffect } from 'react';
import Chart from 'chart.js';

const PieProductBest = () => {
  useEffect(() => {
    var config = {
      type: 'pie',
      data: {
        labels: [
          'Brokoli',
          'Jagung',
          'Wortel',
          'Kentang',
          'Kecambah',
          'Cabe',
          'Bombai',
          'Tomat',
          'Bawang',
          'Kacang',
        ],
        datasets: [
          {
            backgroundColor: [
              '#ce31c1',
              '#31ce58',
              '#296aa7',
              '#3182ce',
              '#f86542',
              '#F86542',
              '#439521',
              '#fcb813',
            ],
            data: [10, 20, 30, 40, 50, 23, 23, 12, 52, 52],
          },
        ],
      },
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: function (tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var meta = dataset._meta[Object.keys(dataset._meta)[0]];
              var total = meta.total;
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = parseFloat(
                ((currentValue / total) * 100).toFixed(1)
              );
              return currentValue + ' (' + percentage + '%)';
            },
            title: function (tooltipItem, data) {
              return data.labels[tooltipItem[0].index];
            },
          },
        },
      },
    };
    var ctx = document.getElementById('pie-product-best').getContext('2d');
    window.myLine = new Chart(ctx, config);
  }, []);

  return (
    <div className="flex flex-col w-full">
      <div className=" w-full my-8">
        <canvas id="pie-product-best"></canvas>
      </div>
      <div className="grid grid-flow-rows grid-cols-4 grid-rows-3 gap-2 text-sm">
        <div className="flex items-center">
          <span
            className="w-5 h-5 mr-1"
            style={{ backgroundColor: '#ce31c1' }}
          ></span>
          <p> Brokoli </p>
        </div>
        <div className="flex items-center">
          <span
            className="w-5 h-5 mr-1"
            style={{ backgroundColor: '#31ce58' }}
          ></span>
          <p> Jagung </p>
        </div>
        <div className="flex items-center">
          <span
            className="w-5 h-5 mr-1"
            style={{ backgroundColor: '#31cece' }}
          ></span>
          <p> Wortel </p>
        </div>
        <div className="flex items-center">
          <span
            className="w-5 h-5 mr-1"
            style={{ backgroundColor: '#296aa7' }}
          ></span>
          <p> Kentang </p>
        </div>
        <div className="flex items-center">
          <span
            className="w-5 h-5 mr-1"
            style={{ backgroundColor: '#3182ce' }}
          ></span>
          <p> Cambah </p>
        </div>
        <div className="flex items-center">
          <span
            className="w-5 h-5 mr-1"
            style={{ backgroundColor: '#3182ce' }}
          ></span>
          <p> Cabe </p>
        </div>
        <div className="flex items-center">
          <span
            className="w-5 h-5 mr-1"
            style={{ backgroundColor: '#f86542' }}
          ></span>
          <p> Bombai </p>
        </div>
        
        <div className="flex items-center">
          <span
            className="w-5 h-5 mr-1"
            style={{ backgroundColor: '#439521' }}
          ></span>
          <p> Tomat </p>
        </div>
        <div className="flex items-center">
          <span
            className="w-5 h-5 mr-1"
            style={{ backgroundColor: '#439521' }}
          ></span>
          <p> Bawang </p>
        </div>
        <div className="flex items-center">
          <span
            className="w-5 h-5 mr-1"
            style={{ backgroundColor: '#fcb813' }}
          ></span>
          <p> Kacang </p>
        </div>
      </div>
    </div>
  );
};

export default PieProductBest;
